import { useInLifeQuoteLoadedTracking } from '@in-life/hooks/useInLifeQuoteLoaded';
import { Outlet } from 'react-router-dom';

import { useScrollTopOnRouteChange } from '@hooks/useScrollToTop';
import { useUpdateLoaderProvider } from '@routing/RouteProvider';

import { useInLifePageTracking } from '../../hooks/useInLifePageTracking';
import { CustomerProfileInfoProvider } from '../CustomerProfileInfoProvider';

// This ensures that the page tracking is only triggered after the customer profile information has been loaded
// or else the initial page view event will be missing the account number
const InLifeTrackedRoutes = ({ children }: { children: React.ReactNode }) => {
  useInLifePageTracking();

  return children;
};

const InLifeRouteProvider = () => {
  useScrollTopOnRouteChange();
  useUpdateLoaderProvider();
  useInLifeQuoteLoadedTracking();

  return (
    <CustomerProfileInfoProvider>
      <InLifeTrackedRoutes>
        <Outlet />
      </InLifeTrackedRoutes>
    </CustomerProfileInfoProvider>
  );
};

export { InLifeRouteProvider };
